import script from "./DataIngestionHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataIngestionHistory.vue?vue&type=script&setup=true&lang=ts"

import "./DataIngestionHistory.vue?vue&type=style&index=0&id=6b4237a6&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b4237a6"]])

export default __exports__